module.exports = __webpack_public_path__ + "img/postman_visiteur_id.d2724c1a.png";